import React from "react";
import Routes from "../routes";
import { Button } from "../stories/atoms/Button";
import { Footer } from "../stories/organisms/Footer";
import { Header } from "../stories/organisms/Header";

// ✅ IMPORTS MUI CORRECTS
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export default function Layout() {
    const [open, setOpen] = React.useState(false);

    // ✅ fonction manquante
    const handleClose = () => setOpen(false);

    return (
        <>
            <Header />

            <main className="main">
                <Routes />

                <div className="vtaleau-container-button">
                    {/* <Button
                        label="Inscriptions et rentrée 2026"
                        primary
                        onClick={() => setOpen(true)}
                        style={{ backgroundColor: "#ffd31c", marginBottom: "10px" }}
                    /> */}

                    <Button
                        label="Réservation adultes"
                        primary
                        target="_blank"
                        href="https://member.resamania.com/vitaleau-verrieresantony/"
                        style={{ backgroundColor: "#ffd31c" }}
                    />
                </div>
            </main>
            {/* ✅ MODAL */}
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth style={{ zIndex: 9999 }}>
                <DialogTitle sx={{ backgroundColor: "#ffd31c", fontWeight: "bold" }}>Inscriptions & RENTRÉE 2026</DialogTitle>

                <DialogContent dividers>
                    <p>
                        Pour information, voici le planning de nos formules annuelles enfants pour la saison <strong>2026/2027</strong>.
                    </p>

                    <br />

                    <h3 className="text-sm">🏊‍♂️ Planning annuel enfants 2026/2027</h3>

                    <p>
                        <strong>Initiation 1 :</strong> Mercredi 14H00 ou 14H45. Samedi 12H40.
                    </p>
                    <p>
                        <strong>Initiation 2 :</strong> Mercredi 15H30 <strong>(complet)</strong>.
                    </p>
                    <p>
                        <strong>Perfectionnement 1 :</strong> Vendredi 17H05.
                    </p>
                    <p>
                        <strong>Perfectionnement 2 :</strong> Vendredi 17H50.
                    </p>
                    <p>
                        <strong>Perfectionnement 3/4 :</strong> Vendredi 18H35 ou 19H20 <strong>(complets)</strong>.
                    </p>
                    <p>
                        <strong>Bébés nageurs :</strong> Samedi 9H, 9H30 <strong>(complet)</strong>, 10H, 10H30 ou 11H.
                    </p>
                    <p>
                        <strong>Section découverte :</strong> Samedi 11H30, 12H00 ou 14H50.
                    </p>

                    <br />

                    <h3>📅 Cycles de Natation / Apprentissage</h3>
                    <p>Planning des cycles de Natation / Apprentissage sur courte durée, renouvelables :</p>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>4 cours le mercredi entre 16H15 et 18H15</li>
                        <li>9 cours le samedi entre 13H20 et 18H00</li>
                    </ul>
                    <br />
                    <p>L’horaire vous sera communiqué le jour du test.</p>

                    <br />

                    <h3>📅 Tests de niveau sans rendez-vous</h3>
                    <p>Nous organisons des sessions de tests de niveaux :</p>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>Mercredis 2/09 et 9/09/26 de 15h15 à 16h15</li>
                        <li>Dimanches 6/09 et 13/09 de 13h à 16h</li>
                    </ul>

                    <br />

                    <p>
                        Venez sur ces créneaux sans rendez-vous, avec une fiche d'inscription complétée enfants ou bébés{" "}
                        <a href="/inscription" target="_blank" style={{ textDecoration: "underline" }}>
                            téléchargeable depuis l'onglet inscription de notre site
                        </a>{" "}
                        pour valider le niveau de votre enfant et son inscription.
                    </p>

                    <br />

                    <p>Pour les plus de 4 ans, pensez au maillot et aux lunettes de piscine.</p>

                    <br />

                    <h3>ℹ️ Informations importantes</h3>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>Les règlements se font uniquement par chèque.</li>
                    </ul>

                    <br />

                    <h3>📆 Dates de reprise</h3>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>
                            Bébés nageurs / Section découverte : <strong>samedi 5 septembre 2026</strong>
                        </li>
                        <li>
                            Cycles de Natation / Apprentissage : <strong>mercredi 2 et samedi 5 septembre 2026</strong>
                        </li>
                        <li>
                            Activités annuelles Initiation / Perfectionnement : <strong>lundi 14 septembre 2026</strong>
                        </li>
                    </ul>

                    <br />

                    <h3>👨‍🦰 Activités adultes</h3>
                    <p>
                        Pour les activités adultes, les inscriptions se font directement en ligne via la plateforme <strong>résamaniaV2</strong> ou au
                        club.
                    </p>

                    <br />

                    <p>
                        Les réservations des séances se font sur le web à la même adresse, ou avec un smartphone via l’application{" "}
                        <strong>résamaniaV2</strong>.
                    </p>

                    <br />

                    <p>
                        <strong>Reprise des activités adultes :</strong> lundi 31 août 2026.
                    </p>

                    <br />

                    <Button
                        primary
                        variant="contained"
                        href="https://member.resamania.com/vitaleau-verrieresantony/"
                        target="_blank"
                        label="Réserver"
                        style={{ backgroundColor: "#ffd31c" }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button primary variant="contained" onClick={handleClose} label="Fermer" />
                </DialogActions>
            </Dialog>
            <Footer />
        </>
    );
}
